// import React, { useState } from 'react';
// import man from '../../assets/man.png';
// import './Faq.css';
// const faqs = [
//     {
//         question: 'In elementum est a ante sodales iaculis.',
//         answer:
//             'Morbi porttitor ligula in nunc varius sagittis. Proin dui nisi, laoreet ut tempor ac, cursus vitae eros. Cras quis ultricies elit.',
//     },
//     {
//         question: 'Etiam lobortis massa eu nibh tempor elementum.',
//         answer:
//             'Etiam efficitur, mauris at feugiat gravida, tellus eros fringilla leo, vitae hendrerit ipsum ex id quam.',
//     },
//     {
//         question: 'Aenean quis quam nec lacus semper dignissim.',
//         answer:
//             'Vivamus ornare commodo ante, at commodo felis congue vitae. Integer feugiat tortor a lorem mattis suscipit.',
//     },
//     {
//         question: 'Nulla tincidunt eros id tempus accumsan.',
//         answer:
//             'Donec a eros non massa vulputate ornare. Maecenas aliquet vel tellus at accumsan.',
//     },
// ];

// const FAQSection = () => {
//     const [openIndex, setOpenIndex] = useState(null);

//     const toggleFAQ = (index) => {
//         setOpenIndex(openIndex === index ? null : index);
//     };

//     return (
//         <div className="faq-section">
//   <div className="faq-box">
//     <h2 className="faq-heading">Welcome, Let’s Talk About Our Ecobazar</h2>
//     {faqs.map((faq, index) => (
//       <div
//         key={index}
//         className={`faq-item ${openIndex === index ? 'open' : ''}`}
//       >
//         <div className="faq-question" onClick={() => toggleFAQ(index)}>
//           {faq.question}
//           <div className="faq-plus">{openIndex === index ? '+' : '+'}</div>
//         </div>
//         <div className="faq-answer">{faq.answer}</div>
//       </div>
//     ))}
//   </div>

//   <img src={man} alt="man_image" className="man-image" />
// </div>

//     );
// };

// export default FAQSection;


import React, { useState } from 'react';
import man from '../../assets/ken.jpg'; // Make sure this path is correct for your image
import './Faq.css';

const faqs = [
    {
        question: 'Who can use the marketplace?',
        answer:
            "The marketplace is for anyone looking to buy agricultural products. Whether you're a home gardener, reseller, or commercial farmer, you can purchase directly from verified farmers and agri-suppliers across Kenya.",
    },
    {
        question: 'Are the sellers verified?',
        answer:
            'Yes, all sellers on our platform are verified to ensure quality and authenticity of products.',
    },
    {
        question: 'Is it free to buy from the marketplace?',
        answer:
            'No, to access the marketplace, users need a monthly subscription of KSh 350 plus 16% VAT, making the total KSh 406.',
    },
    {
        question: ' Is the Shambasync mobile app free to download?',
        answer:
            'Yes, both the Shambasync User App and Seller App are free to download on the Play Store and App Store. They work seamlessly across devices, helping buyers and sellers stay connected anytime, anywhere.',
    },
];

const FAQSection = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="faq-section-container">
            <div className="faq-left-panel">
                <img src={man} alt="Smiling person with phone" className="faq-panel-image" />
            </div>
            <div className="faq-right-panel">
                <p className="faq-our-faqs-text">OUR FAQs</p>
                <h2 className="faq-main-heading-text">Have Questions? Look Here</h2>
                <p className="faq-description-text">
                    Got questions? We've got answers! Check out our FAQs to find the information you need, or reach out to our support team for personalized assistance.
                </p>
                <div className="faq-questions-box">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`faq-item ${openIndex === index ? 'open' : ''}`}
                        >
                            <div className="faq-question" onClick={() => toggleFAQ(index)}>
                                {faq.question}
                                {/* Changed icon logic for clear +/- */}
                                <div className="faq-plus">{openIndex === index ? '-' : '+'}</div>
                            </div>
                            <div className="faq-answer">{faq.answer}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FAQSection;
